import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ExampleComponentType } from '../../types';
import InfoIcon from '@mui/icons-material/Info';
import { htmlParser } from 'helpers/applangaHtmlParser';
import backIcon from 'assets/images/icons/back_icon.svg';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { USER_SETTINGS } from 'utils/config/constants/controllerNames';
import { onUpdateDoc } from 'utils/config/firebase';
import { setUserSettings } from 'store/auth/authSlice';

const Example: FC<ExampleComponentType> = ({ exampleId, label, onCloseExamples }) => {
    const { t } = useTranslation();
    const { userSettings } = useAppSelector((state) => state.auth);
    const dispatch = useAppDispatch();

    const translatedText = t(`web_app.additional_settings.examples.${exampleId}`);
    const isLong = translatedText?.length > 600;
    const body = isLong ? translatedText?.slice(0, 600) : translatedText;

    const dontShowAgainExamples = () => {
        if (userSettings) {
            dispatch(
                setUserSettings({ ...userSettings, dont_show_additional_settings_example: true }),
            );
            onUpdateDoc(USER_SETTINGS, userSettings.document_id, {
                dont_show_additional_settings_example: true,
            });
        }
        onCloseExamples();
    };

    return (
        <>
            <Box className={`example-container fade-in ${exampleId ? 'active' : ''}`}>
                <Box className="example-container-header">
                    <button onClick={onCloseExamples}>
                        <img src={backIcon} alt="back_icon" />
                    </button>

                    <button onClick={dontShowAgainExamples}>
                        {t('web_app.additiona_settings.dont_show_examples')}
                    </button>
                </Box>

                <Typography className="title" variant="h5">
                    {t('web_app.additional_settings.examples.label')}
                </Typography>
                <Typography className="subtitle" variant="h6">
                    {label}
                </Typography>
                <Typography className={`body ${isLong ? 'example-body' : ''}`} variant="body2">
                    {htmlParser(body)}
                </Typography>
                <Box className="example-container-info">
                    <InfoIcon sx={{ fontSize: 25 }} />
                    {t('web_app.additional_settings.examples.info')}
                </Box>
            </Box>
        </>
    );
};

export default Example;
